import React from "react";
import work from "../content/work";

const WorkGrid = ({ limit }) => {
  const list = limit ? work.slice(0, limit) : work;
  return (
    <div className="work-grid">
      {list.map((w) => (
        <article key={w.code} className="work">
          <div className="work-head">
            <span className="code">{w.code}</span>
            <span className={`state s-${w.state}`}>{w.state.toUpperCase()}</span>
          </div>
          <div className="sector">{w.sector}</div>
          <h3 className="title">{w.title}</h3>
          <div className="stack">
            {w.services.map((s) => <span key={s} className="pill">{s}</span>)}
          </div>
          <div className="meta">
            <span>{w.year}</span>
            <span className="span">{w.span}</span>
          </div>
        </article>
      ))}
    </div>
  );
};

export default WorkGrid;
